/* eslint-disable import/order */
import { initI18n } from 'scbk-services';
import { registerResources as registerSharedModuleResources } from 'scbk-shared-module';

import { registerResources as registerBancaResources } from 'scbk-banca';
import { registerResources as registerCardResources } from 'scbk-card';
import { registerResources as registerCertificatesResources } from 'scbk-certificates';
import { registerResources as registerCertificationResources } from 'scbk-certification';
import { registerResources as registerCommonsResources } from 'scbk-commons';
import { registerResources as registerDepositResources } from 'scbk-deposit';
import { registerResources as registerFrontSampleResources } from 'scbk-frontend-sample';
import { registerResources as registerFundResources } from 'scbk-fund';
import { registerResources as registerFxResources } from 'scbk-fx';
import { registerResources as registerKeylandingResources } from 'scbk-keylanding';
import { registerResources as registerLoansResources } from 'scbk-loans';
import { registerResources as registerLoginResources } from 'scbk-login';
import { registerResources as registerServicingResources } from 'scbk-servicing';
import { registerResources as registerSettingsResources } from 'scbk-settings';
import { registerResources as registerTransferResources } from 'scbk-transfer';
import { registerResources as registerTrustResources } from 'scbk-trust';

import { registerResources as registerCoreModuleResources } from './index';

export interface BootstrapI18nOptions {
    /**
     * 사용할 locale.
     *
     * 예: ko, en, ko-KR
     */
    lng: string;

    /**
     * fallback locale.
     */
    fallbackLng?: string;

    /**
     * 적용할 market.
     *
     * 예: kr
     */
    market: string;
}

/**
 * core i18n bootstrap.
 *
 * 실행 순서:
 * 1. services singleton i18n init
 * 2. shared-module resource 등록
 * 3. login resource 등록
 * 4. 기타 feature resource 등록
 * 5. App render
 *
 * 주의:
 * React render 중에 호출하지 않는다.
 * main.tsx 또는 app bootstrap 단계에서 먼저 await 한다.
 */
export const bootstrapI18n = async ({ lng, fallbackLng = 'ko', market }: BootstrapI18nOptions) => {
    const i18n = await initI18n({
        lng,
        fallbackLng,
        defaultNS: 'translation',
        ns: ['translation'],
    });

    registerSharedModuleResources({
        market,
    });
    registerBancaResources({
        market,
    });
    registerCardResources({
        market,
    });
    registerCertificatesResources({
        market,
    });
    registerCertificationResources({
        market,
    });
    registerCommonsResources({
        market,
    });
    registerDepositResources({
        market,
    });
    registerFundResources({
        market,
    });
    registerFxResources({
        market,
    });
    registerKeylandingResources({
        market,
    });
    registerLoansResources({
        market,
    });
    registerLoginResources({
        market,
    });
    registerServicingResources({
        market,
    });
    registerSettingsResources({
        market,
    });
    registerTransferResources({
        market,
    });
    registerTrustResources({
        market,
    });
    registerFrontSampleResources({
        market,
    });
    registerCoreModuleResources({
        market,
    });

    return i18n;
};
